import {FC} from "react";

type Props = {
  className?: string
}

export const IconDownArrow: FC<Props> = ({className = ""}) =>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className={`w-6 h-6 ${className}`}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
  </svg>;

export const IconUpArrow: FC<Props> = ({className = ""}) =>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className={`w-6 h-6 ${className}`}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5"/>
  </svg>;

export const IconChevronLeft: FC<Props> = ({className}) =>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
       className={`w-6 h-6 ${className}`}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
  </svg>

export const IconEye: FC<Props> = ({className}) =>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M12.0584 17.2488C16.6415 17.2488 20.357 11.9818 20.357 11.9818C20.357 11.9818 16.6415 6.71466 12.0584 6.71466C7.47522 6.71466 3.75977 11.9818 3.75977 11.9818C3.75977 11.9818 7.47522 17.2488 12.0584 17.2488Z"
      stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path
      d="M12.0583 14.7481C13.5861 14.7481 14.8246 13.5096 14.8246 11.9818C14.8246 10.454 13.5861 9.21552 12.0583 9.21552C10.5305 9.21552 9.29199 10.454 9.29199 11.9818C9.29199 13.5096 10.5305 14.7481 12.0583 14.7481Z"
      stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>

export const IconEyeClosed: FC<Props> = ({className}) =>
  <svg className={className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_185)">
      <path
        d="M14.0149 13.8679C13.4961 14.3867 12.7925 14.6782 12.0588 14.6782C11.3251 14.6782 10.6215 14.3867 10.1027 13.8679C9.58393 13.3491 9.29248 12.6455 9.29248 11.9118C9.29248 11.1782 9.58393 10.4745 10.1027 9.95575"
        stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M18.4751 14.041C19.1624 13.3866 19.7921 12.6742 20.3571 11.9117C20.3571 11.9117 16.6416 6.64453 12.0584 6.64453C11.7543 6.64598 11.4506 6.66981 11.1499 6.71584"
        stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M8.04852 7.90155C6.38938 8.96944 4.93653 10.3279 3.75977 11.9117C3.75977 11.9117 7.47531 17.1789 12.0585 17.1789C13.4853 17.1357 14.8726 16.7008 16.0687 15.9218"
        stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.42725 5.4552L18.5157 17.5436" stroke="#1C1F22" strokeWidth="1.4" strokeLinecap="round"
            strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1_185">
        <rect width="24" height="24" fill="white" transform="translate(0.0585938)"/>
      </clipPath>
    </defs>
  </svg>

export const IconUser = ({className}: { className?: string }) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
              className={className}>
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/>
  </svg>
}

export const IconEmail: FC<IconProps> = ({size = 16}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
              height={size} width={size}>
    <path strokeLinecap="round" strokeLinejoin="round"
          d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/>
  </svg>
}

export const IconWakeletBlueW = ({size}: { size: number }) => {
  return <span className="fill-[var(--color-logo-primary)] sm:flex" title="wakelet">
          <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24 4.1v.3l-.6 1.8c-1.4.1-2.7.4-4.2.7l.6-2.5c.1-.5.4-.8 1-.8h2.7c.4 0 .5.2.5.5zm-10 .1c-.1-.4-.4-.6-.9-.6h-1.9c-.4 0-.8.2-.9.7l-2 6.8C10.7 9.8 13 8.8 15.2 8L14 4.2zm-9.5.1c-.1-.4-.3-.7-1-.7H.7c-.5 0-.7.2-.7.5v.3l3 9.8 3.3-2.1-1.8-7.8zm12.7 11-1.7-6c-1.1.3-2.2.6-3.3 1l2.7 9.2c.2.6.4.9 1.1.9h2.4c.6 0 .9-.3 1.1-.8L23 8.2c-1.3.1-2.6.2-4 .4l-1.8 6.7zM7 15.2l-.6-2.5c-1.1.5-2.2 1.1-3.4 1.8l1.5 5.1c.1.5.5.8 1.1.8H8c.6 0 .9-.2 1.1-.8l2.6-9.1c-1.2.4-2.5.9-3.7 1.5l-1 3.2z"/>
          </svg>
    </span>
}

export const IconWakeletWhiteW = ({size}: { size: number }) => {
  return <span
    className="shrink-0 !fill-[var(--color-logo-primary)] hover:!fill-[color:var(--color-text-secondary)] sm:flex"
    role="img"
    aria-labelledby="Wakelet"
  >
        <title id="wk-logo-title">Wakelet</title>
        <svg
          width={size}
          height={size}
          viewBox="0 0 64 64"
          fill="blue"
          xmlns="http://www.w3.org/2000/svg">
            <rect width="64" height="64" rx="16" fill="var(--color-logo-primary, #00A9F4)"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 19h8.488l3.003 13.221c-3.22 1.697-5.484 3.13-6.47 3.775L12.028 19.1 12 19Zm40 0-.03.104-1.258 4.091c-2.722.359-5.42.881-8.079 1.564L44.008 19H52Zm-16.478 0h-6.576l-3.61 12.291a90.95 90.95 0 0 1 12.236-5.038L35.522 19Zm2.793 9.842 1.827 6.454 1.707-7.219a93.14 93.14 0 0 1 7.745-1.196L43.749 46.21h-7.486l-4.374-15.145-4.295 15.15h-7.56L17.044 36.1a123.852 123.852 0 0 1 6.687-2.794l.43 1.897.687-2.313c4.4-1.631 8.897-2.983 13.467-4.048Z"
                  fill="var(--color-logo-secondary, white)"/>
        </svg>
    </span>
}

type IconProps = {
  size?: number
}
